<template>
  <table class="min-w-full border-separate text-sm" style="border-spacing: 0">
    <thead>
      <tr>
        <th
          class="bg-surface-overlay sticky top-0 z-10 border-b px-2 py-1 text-left font-semibold whitespace-nowrap"
        >
          {{ $t('attributes.emission_date') }}
        </th>
        <th
          class="bg-surface-overlay sticky top-0 z-10 border-b px-2 py-1 text-left font-semibold whitespace-nowrap"
        >
          {{ $t('attributes.payment_mode') }}
        </th>
        <th
          class="bg-surface-overlay sticky top-0 z-10 border-b px-2 py-1 text-left font-semibold whitespace-nowrap"
        >
          {{ $t('attributes.reference') }}
        </th>
        <th
          class="bg-surface-overlay sticky top-0 z-10 border-b px-2 py-1 text-right font-semibold whitespace-nowrap"
        >
          {{ amountHeading }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="payment in sortedPayments" :key="payment.id">
        <td class="border-b px-2 py-1 whitespace-nowrap">
          {{ emissionDate(payment) }}
        </td>
        <td class="border-b px-2 py-1 whitespace-nowrap">
          {{ paymentModeLabel(payment) }}
        </td>
        <td class="border-b px-2 py-1 whitespace-nowrap">
          {{ reference(payment) }}
        </td>
        <td class="border-b px-2 py-1 text-right whitespace-nowrap">
          {{ amount(payment) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentListTable',
  props: {
    payments: {
      type: Array,
      required: true
    },
    currency: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      payment_modes: 'metadata/getPaymentModesMetadata'
    }),
    // The currency sits in the heading so the cells stay plain numbers that a
    // spreadsheet reads as such once the table is copied.
    amountHeading() {
      const heading = this.$t('attributes.amount')
      return this.currency ? `${heading} (${this.currency})` : heading
    },
    sortedPayments() {
      return [...this.payments].sort((a, b) =>
        String(a.emission_date ?? '').localeCompare(
          String(b.emission_date ?? '')
        )
      )
    }
  },
  methods: {
    emissionDate(payment) {
      return payment.formatted_emission_date || payment.emission_date || ''
    },
    paymentModeLabel(payment) {
      return (
        this.payment_modes?.find(
          (payment_mode) => payment_mode.id === payment.payment_mode
        )?.name ?? ''
      )
    },
    amount(payment) {
      const htmlLang = document.documentElement.lang
      const locale =
        htmlLang && htmlLang !== 'default'
          ? htmlLang.replace('_', '-')
          : 'fr-BE'
      return Number(payment.amount).toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        useGrouping: false
      })
    },
    reference(payment) {
      return payment.check_number || ''
    }
  }
}
</script>
